import React from 'react'
import { triggerClickOnCanvas } from 'helpers/triggerClickOnCanvas'
import { StyledAnswerButtonLight as S } from './AnswerButtonLight.styles'

type TProps = {
  children?: React.ReactNode
}

export const AnswerButtonLight: React.FC<TProps> = ({ children }) => {
  return <S.Content onClick={triggerClickOnCanvas}>{children}</S.Content>
}
